import * as _ from 'lodash';
import * as React from 'react';
import { styled } from '../../theme';
import { SwitchLabelWidget } from '../switch/SwitchLabelWidget';

export type MultipleSelectOptionType = {
  label: string;
  value: string;
  disabled?: boolean;
};

export interface MultipleSelectWidgetProps {
  options: MultipleSelectOptionType[];
  selected: string[];
  onSelect: (selected: string[]) => void;
}

namespace S {
  export const Container = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 2px;
  `;

  export const SwitchLabel = styled(SwitchLabelWidget)`
    background: ${(p) => p.theme.forms.input.background};
    border-radius: 3px;
  `;
}

export const MultipleSelectWidget: React.FC<MultipleSelectWidgetProps> = (props) => {
  const { options, selected } = props;
  return (
    <S.Container>
      {options.map((option) => (
        <S.SwitchLabel
          key={option.value}
          checked={selected.includes(option.value)}
          label={option.label}
          onChange={(checked) => {
            const update = [...selected];
            if (checked) {
              update.push(option.value);
            } else {
              _.pull(update, option.value);
            }
            props.onSelect(_.uniq(update));
          }}
          disabled={option.disabled}
        />
      ))}
    </S.Container>
  );
};
